import { Box, Button, CircularProgress, Dialog, DialogActions, DialogContent, Divider, Grid, Hidden, SelectChangeEvent, Skeleton, Theme, Typography, useTheme } from '@mui/material';
import React, { useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import { RootStateType } from '../../../redux-store/reducers';
import BreadCrum from '../../../lib/BreadCrum';
import { getMandatesList, setAppliedFundsFilters, setCheckedHoldingSchemes, setSelectedAllHoldingsInfo, setSelectedHoldingsIds, setSelectedHoldingsInfo, setSelectedSchemesObj } from '../../../redux-store/actions/investorProfile';
import HoldingFundMore from '../common/HoldingFundMore';
import MoreFundsModal from '../common/MoreFundsModal';
import { HoldingsTableData } from '../mutualFund/holdings/types';
import ConfirmRecomment from '../common/ConfirmRecomment';
import RiskProfilePopup from '../common/RiskProfilePopup';
import AddtoCardPopup from '../common/AddtoCardPopup';
import SuccessModal from '../common/SuccessModal';
import FiveSchemeErrorMessage from '../mutualFund/common/FiveSchemeErrorMessage';
import ValidateDialogBox from '../mutualFund/common/ValidateDialogBox';
import { applicantStatusMasters, BANK_SUB_ACCOUNT_TYPES, ENABLE_MF_TRANSACTIONS_POA_DOCUMENT_UPLOAD, MAX_SCHEMES_SELECTED, MPOWER_ACCOUNT_TYPE_MASTER, USER_ROLES } from '../../../utils/constant';
import { FieldArray, Form, Formik, FormikProps, FormikValues } from '../../../lib/formik/Formik';
import { BluePlusIcon, EmailIcon, FailureIcon, Phoneicon } from '../../../assets/SvgIcons';
import { addWorkingDays, findNextValidDate, formatCurrency, isModuleAllowed, isOnboardingTypeMinor, maskInfo, toINR } from '../../../utils/utilityFunctions';
import { GETINVESTMENTDETAILTYPE, GetInvestmentUserDetails } from '../../../redux-store/types/api-types';
import { getInvestmentDetails, getInvestmentUserDetails, getRiskProfileCheck, submitInvestmentDetails, submitRecomment } from '../../../redux-store/actions/funds';
import { MandatesListResBody } from '../../../redux-store/types/investorProfile';
import Card from './Card';
import * as Yup from 'yup';
import { MpowerValidationType } from '../types';
import dayjs from '../../../utils/dayjs';
import { addToCart, getCartItemsCount, setCartItemsCount } from '../../../redux-store/actions/cart';
import { AddToCartResponseBody, GetCartItemsCountResponseBody } from '../../../redux-store/types/cart';
import { handleDateValidation } from './Sip';
import TransactionsDocumentUpload from '../../../lib/TransactionsDocumentUpload';
import { BankDetails, GetBankBalanceResponseBody, GetOrderEntryBanksListResponseBody } from '../../../redux-store/types/orderManagement';
import { getBankBalance, getOrderEntryBanksList } from '../../../redux-store/actions/orderManagement';
import { CustomeBlueDropDown } from './FromInput';
import { CustomeButton } from '../../../lib/formik/NewFormInputs';
import { showError } from '../../../redux-store/actions/auth';
import { getAbbreviatedName } from '../../commonComponents';

// For RIA:
// IA Role:
// ADVISORY/POA & EXY
//   Recommend Only

// RSM Role:
// ADVISORY/POA & Exy
// Order Placement
// No recommend

// RM Role: 
// No order placement, no Recommendation

// OPE & OPM:
// Order placement (ADVISORY/POA & EXY)
// Order Recommendation (ADVISORY/POA & EXY)


const initialData = {
    fund: [
        {
            sip: {
                sipamount: '',
                periods: '',
                installments: '',
                sipDate: '',
                sipEndDate: '',
                mandate: '',
                sipFolio: '',
                firstOrder: true,
            },
            lumpsum: {
                lumpAmount: '',
                lumpsumFolio: '',
            },
            activeTab: 'Lumpsum',
        },

    ]
}


const Transaction = () => {
    const { palette, typography } = useTheme();
    const history = useHistory();
    const { pathname, state } = history.location;
    const dispatch = useDispatch();
    const {
        role = '',
        permissions = []
    } = useSelector((store: RootStateType) => store.auth);

    const {
        selectedSchemesObj = {},
        selectedHoldingsIds,
        selectAllHoldingsInfo
    } = useSelector((store: RootStateType) => store.investorProfile);
    const {
        selectedPortfolio,
        selectedPortfolioObj
    } = useSelector((store: RootStateType) => store.selectedPortfiolio);

    const { iwappRmId = "", clientInterfaceCode } = useSelector((store: RootStateType) => store.id)
    const { investorRmId = "" } = useSelector((store: RootStateType) => store.sessionData)
    const { locale, currencyCode, currencySymbol } = useSelector((store: RootStateType) => store.currencyInfo);

    const {
        selectedSchemes = [],
        clientCode,
        folio = [],
        schemeDetails = []
    } = (state as {
        selectedSchemes?: any[],
        clientCode: string,
        folio?: {
            folioId?: string,
            schemeId?: string,
            marketValue: number,
            investedValue: number,
            id: string
        }[],
        schemeDetails?: {
            scheme_id: string,
            isReinvestment: string
        }[]
    }) ?? []

    const [schemeAllDetails, setSchemeAllDetails] = useState<Array<{ scheme_id: string, isReinvestment: string }>>(schemeDetails);

    const formRef = useRef<FormikProps<FormikValues>>(null);

    //state
    const [open, setOpen] = useState(false);
    const [holdingsData, setHoldingsData] = useState<HoldingsTableData[]>([])
    const [apiLoading, setApiLoading] = useState<'order' | 'recomment' | 'investor' | "">("");
    const [confirmRecomment, setConfirmRecomment] = useState(false);
    const [orderType, setOrderType] = useState<'order' | 'recomment' | 'investor'>('order');
    const [riskProfilePopup, setRiskProfilePopup] = useState<boolean>(false);
    const [riskPopupText, setRiskPopupText] = useState<string>('');
    const [riskProfileCheckResponse, setRiskProfileCheckResponse] = useState<{ isSuccess: boolean; displayText: string }>({} as {
        isSuccess: boolean,
        displayText: string
    })
    const [cartPopup, setCartPopup] = useState<boolean>(false);
    const [isFiveSchemesDialogVisible, setFiveSchemesDialogVisible] = useState<boolean>(false)
    const [isValidationDialogVisible, setValidationDialogVisible] = useState<boolean>(false)
    const [validationErrorsArray, setValidationErrorsArray] = useState<{ schemeName: string; errorMessage: string }[]>([])
    const [riskPflChkLoading, setRiskPflChkLoading] = useState<boolean>(false);
    const [successModal, setSuccessModal] = useState(false);
    const [userLoading, setUserLoading] = useState(false);
    const [userDetails, setUserDetails] = useState<GetInvestmentUserDetails>({} as GetInvestmentUserDetails);
    const [isLoading, setIsLoading] = useState(true);
    const [details, setDetails] = useState<GETINVESTMENTDETAILTYPE>({} as GETINVESTMENTDETAILTYPE);
    const [activeMandateList, setActiveMandateList] = useState<MandatesListResBody[]>([]);
    const [formInitialData, setFormInitialData] = useState(initialData);
    const [isDocumentUploadDialogVisible, setDocumentUploadDialogVisible] = useState<boolean>(false);
    const [isDocumentUploadErrorDialogVisible, setDocumentUploadErrorDialogVisible] = useState<boolean>(false);
    const [recommendPlaceOrderResponse, setRecommendPlaceOrderResponse] = useState<any>({})
    const [bankAccountList, setBankAccountList] = useState<GetOrderEntryBanksListResponseBody>({} as GetOrderEntryBanksListResponseBody)
    const [isBankBalanceObjLoading, setBankBalanceObjLoading] = useState<boolean>(false)
    const [bankBalanceObj, setBankBalanceObj] = useState<GetBankBalanceResponseBody>({} as GetBankBalanceResponseBody)
    const [isSameSchemesDialogOpen, setSameSchemesDialogOpen] = useState<boolean>(false)

    //AddMore fund Model
    const [radioValue, setRadioValue] = useState<any[]>([]);
    const [warning, setWarning] = useState<boolean>(false);

    const isInvestMore = pathname.split('/')[pathname.split('/').length - 1] === 'invest-more'

    const investmentDetailsSchema = Yup.object().shape({
        fund: Yup.lazy((_value) => {
            const getValidation = (index: number, type: "SUB" | "RED" | "SIP" | "STP" | "SWP"): MpowerValidationType => {
                const validationData = _value[index]?.validations?.filter((item: MpowerValidationType) => item?.transactionType === type)[0] ?? {}
                return validationData
            }
            const getDateValidation = (index: number, type: "SUB" | "RED" | "SIP" | "STP" | "SWP", period: string): MpowerValidationType => {
                const validationData = _value[index]?.validations?.filter((item: MpowerValidationType) => item?.transactionType === type && item.frequency === period)[0] ?? {}
                return validationData
            }
            return Yup.array().of(
                Yup.object().shape({
                    sip: Yup.object().nullable().default(null).when('activeTab', {
                        is: 'SIP',
                        then: Yup.object().shape({
                            sipamount: Yup.number().required('SIP Amount is Required').positive('Amount must be greater than zero').test('validations', '', function (value, context) {
                                const { parent, createError, path } = context;
                                const index = Number(path.match(/[\d,]+/g)?.[0])
                                const validationData = getDateValidation(index, 'SIP', parent?.periods)
                                return Number(value) >= (validationData?.minimumInstallmentAmount || 0) ? true : createError({ path, message: `Minimum amount is ${validationData?.minimumInstallmentAmount}` });
                            }),
                            periods: Yup.string().required('Frequency is Required'),
                            installments: Yup.number().test('validations', '', function (value, context) {
                                const { parent, createError, path } = context;
                                const index = Number(path.match(/[\d,]+/g)?.[0])

                                if (`${parent?.periods ?? ""}`.toUpperCase() === 'DAILY') {
                                    return true
                                }

                                if (!`${value ?? ""}`.length) {
                                    return createError({ path, message: 'Installment is Required' })
                                }

                                const validationData = getDateValidation(index, 'SIP', parent?.periods)
                                return Number(value) >= (validationData?.minimumInstallments || 0) ? true : createError({ path, message: `Minimum installments is ${validationData?.minimumInstallments}` });
                            }),
                            sipDate: Yup.date().nullable().typeError('Invalid Date').test('validations', '', function (value, context) {
                                const { parent, createError, path } = context;
                                const index = Number(path.match(/[\d,]+/g)?.[0])
                                const validationData = getDateValidation(index, 'SIP', parent?.periods)

                                if (!value) {
                                    return createError({ path, message: `SIP ${parent?.periods === 'DAILY' ? "Start" : ""} Date is Required` });
                                }

                                // If mandate is active (non-first order)
                                if (!parent?.firstOrder) {
                                    // For past date
                                    if ((dayjs(new Date()).isAfter(value, 'day'))) {
                                        return createError({ path, message: 'Past date is not allowed' });
                                    }
                                    // Earliest allowed date is T+3 working days (Mon–Fri).
                                    // Using working-day arithmetic ensures e.g. Thursday + 3 = Tuesday,
                                    // not Sunday which would confusingly hit the weekend rule instead.
                                    const minWorkingDate = addWorkingDays(dayjs(), 3);
                                    if (dayjs(value).isBefore(minWorkingDate, 'day')) {
                                        return createError({ path, message: `Minimum start date is ${minWorkingDate.format('DD/MM/YYYY')}` });
                                    }
                                    // Only working days (Mon–Fri) are allowed for non-first orders.
                                    if (dayjs(value).day() === 0 || dayjs(value).day() === 6) {
                                        return createError({ path, message: 'Please select a working day (Monday to Friday)' });
                                    }
                                    const valid = handleDateValidation(validationData?.investmentDates, dayjs(value))
                                    if (valid) {
                                        return createError({
                                            message: `Only ${validationData?.investmentDates.join(', ')} are allowed`,
                                            path
                                        })
                                    }
                                    return true
                                }

                                if (parent?.firstOrder) {
                                    const effectiveDate = dayjs().add(31, 'days');
                                    if (dayjs(value).isBefore(effectiveDate, 'day')) {
                                        return createError({ path, message: `Date should be ${effectiveDate.format('DD/MM/YYYY')} and onwards` });
                                    }
                                }

                                const invalid = handleDateValidation(validationData?.investmentDates, dayjs(value));
                                if (invalid) {
                                    return createError({
                                        path,
                                        message: `Only ${validationData?.investmentDates.join(', ')} are allowed`,
                                    });
                                }
                                return true
                            }),
                            mandate: Yup.string().required('Mandate is Required'),
                            ...(isInvestMore ? {} : {
                                sipFolio: Yup.string().required('Required'),
                            }),
                            sipEndDate: Yup
                                .date()
                                .nullable()
                                .typeError('Invalid Date')
                                .test('sip-end-date-check', (value, context) => {
                                    const { parent, path, createError } = context

                                    if (parent?.periods === 'DAILY') {
                                        if (!value) {
                                            return createError({
                                                message: 'SIP End Date is Required',
                                                path,
                                            });
                                        }
                                        if (parent?.sipDate && value && dayjs(value)?.isBefore(dayjs(parent?.sipDate))) {
                                            return createError({
                                                message: 'End date should be greater than start date',
                                                path
                                            })
                                        }

                                        return true
                                    }
                                    return true
                                })
                        }),
                        otherwise: Yup.object().shape({
                            sipamount: Yup.number().notRequired(),
                            periods: Yup.string().notRequired(),
                            installments: Yup.number().notRequired(),
                            sipDate: Yup.date().notRequired(),
                            sipEndDate: Yup.date().notRequired(),
                            mandate: Yup.string().notRequired(),
                            sipFolio: Yup.string().notRequired(),
                        })
                    }),
                    lumpsum: Yup.object().nullable().default(null).when('activeTab', {
                        is: 'Lumpsum',
                        then: Yup.object().shape({
                            lumpAmount: Yup.number().required('Lumpsum Amount is Required')
                                .positive('Amount must be greater than zero')
                                .test('validations', '', function (value, context) {
                                    const { parent, createError, path } = context;
                                    const index = Number(path.match(/[\d,]+/g)?.[0])
                                    const validationData = getValidation(index, 'SUB')

                                    const isNewFolioSelected = `${parent?.lumpsumFolio ?? ""}`?.toLowerCase() === "new folio"

                                    let minLumpsumAmount = validationData?.minimumInstallmentAmount ?? 0

                                    if (isInvestMore || (!isInvestMore && !isNewFolioSelected)) {
                                        minLumpsumAmount = validationData?.addtionalMinimumPurchaseAmpunt ?? 0;
                                    }

                                    return Number(value) >= (minLumpsumAmount || 0) ? true : createError({ path, message: `Minimum amount is ${String.fromCharCode(parseInt(currencySymbol, 16))} ${minLumpsumAmount}` });
                                }),
                            ...(isInvestMore ? {} : {
                                lumpsumFolio: Yup.string().required('Folio is Required'),
                            }),
                        }),
                        otherwise: Yup.object().shape({
                            lumpAmount: Yup.number().notRequired(),
                            lumpsumFolio: Yup.string().notRequired(),
                        })
                    }),
                })
            )
        }),
        ...((![USER_ROLES.INVESTOR].includes(role)) ? {
            documents: Yup.array().of(
                Yup.object().shape({
                    documentId: Yup.string(),
                    documentType: Yup.string()
                })
            )
        } : {}),
        bankAccountNumber: Yup.string().required("Bank Account is Required")
    });


    const fetchAll = async () => {
        try {
            if (!(selectedSchemes ?? []).length) {
                setIsLoading(false)

                setFormInitialData({
                    fund: [],
                    ...((![USER_ROLES.INVESTOR].includes(role)) ? {
                        documents: [{
                            documentId: "",
                            documentType: ""
                        }]
                    } : {}),
                    bankAccountNumber: ""
                } as any);

                return
            }

            setIsLoading(true);

            const payload = {
                schemeIds: selectedSchemes?.map((item: any) => item?.scheme ? item?.scheme : item),
                portfolioId: selectedPortfolio?.value,
                clientCode: clientCode,
                rmId: `${investorRmId}`,
                schemeDetails: selectedSchemes?.map((obj: any) => ({
                    scheme_id: obj?.scheme ?? "",
                    isReinvestment: obj?.isReinvestment ? obj?.isReinvestment : obj?.divReinvestAllowed ?? "",
                }))
            }

            const [mandateListResponse, investmentDetailsResponse] = await Promise.all([
                (dispatch(getMandatesList({ clientCode: clientCode, status: "Active", portfolioId: selectedPortfolio?.value })) as unknown as Promise<Array<MandatesListResBody>>),
                (dispatch(getInvestmentDetails(payload))) as GETINVESTMENTDETAILTYPE | unknown,
            ]);

            setActiveMandateList(mandateListResponse);
            setDetails(investmentDetailsResponse as GETINVESTMENTDETAILTYPE);

            const getOrderEntryBanksListResponse = await (dispatch(getOrderEntryBanksList({
                clientCode
            })) as unknown as Promise<GetOrderEntryBanksListResponseBody>);

            setBankAccountList(getOrderEntryBanksListResponse)

            const formInitial = [...((investmentDetailsResponse as GETINVESTMENTDETAILTYPE)?.investmentDetails || [])]?.map((item, i) => {

                const currentFrequency = item?.frequencies.filter((freq) => freq.tranasactionType === 'SIP')[0]?.frequency || ''

                const sipValidations = item?.validations?.filter((freq: any) => freq?.transactionType === 'SIP')

                const currentFrequencyValidation = (sipValidations ?? []).filter((obj: any) => `${obj?.frequency ?? ""}`.toLowerCase() === `${currentFrequency ?? ""}`.toLowerCase())

                const investmentDates = currentFrequencyValidation?.[0]?.investmentDates || [];

                return {
                    sip: {
                        sipamount: '',
                        periods: currentFrequency,
                        installments: '',
                        sipDate: findNextValidDate(investmentDates, true),
                        sipEndDate: '',
                        mandate: mandateListResponse[0]?.mandateId || '',
                        sipFolio: item?.folios?.availableFolios[0] || '',
                        firstOrder: true,
                    },
                    lumpsum: {
                        lumpAmount: '',
                        lumpsumFolio: item?.folios?.availableFolios[0] || '',
                    },
                    activeTab: 'Lumpsum',
                    schemeId: item.schemeId,
                    mandate: mandateListResponse,
                    folio: folio[i],
                    ...(isInvestMore ? {
                        uniqueId: selectedSchemes?.[i]?.uniqueId ?? ""
                    } : {}),
                    ...item,
                }
            })

            setFormInitialData({
                fund: formInitial,
                ...((![USER_ROLES.INVESTOR].includes(role)) ? {
                    documents: [{
                        documentId: "",
                        documentType: ""
                    }]
                } : {}),
                bankAccountNumber: ""
            } as any);
        } catch (e) {
            console.log('error', e);
            throw e
        } finally {
            setIsLoading(false);
        }
    };

    const getUserData = async () => {
        try {
            setUserLoading(true);
            if (clientCode) {

                const investmentUserDetailsResponse = (await dispatch(getInvestmentUserDetails({
                    clientCode,
                    portfolioId: selectedPortfolio?.value
                }))) as unknown | GetInvestmentUserDetails;

                setUserDetails(investmentUserDetailsResponse as GetInvestmentUserDetails);
            }
        } catch (error) {
            console.log("Error: ", error)
        } finally {
            setUserLoading(false)
        }
    }

    useEffect(() => {
        const getDataFromApi = async () => {
            await Promise.allSettled([fetchAll(), getUserData()])
        }
        if (clientCode) getDataFromApi()
    }, [clientCode]);

    //router for bread crum
    const initialRouter = pathname?.split('/').filter((item) => item !== '')

    const rmRouterPath = (isModuleAllowed({ value: "MFDashboard", compareArr: permissions, objKey: "permissonCode" }) ? [
        {
            name: 'Dashboard',
            path: '/dashboard',
            warning: selectedSchemes?.length > 0,
            handleClick: () => {
                dispatch(setSelectedAllHoldingsInfo([]))
            }
        },
        {
            name: initialRouter[1] + `${selectedPortfolio.label ? ` (${selectedPortfolio.label})` : ''}`,
            path: `/${initialRouter[0]}/${initialRouter[1]}`,
            state: {
                clientCode
            },
            warning: selectedSchemes?.length > 0,
            handleClick: () => {
                dispatch(setSelectedAllHoldingsInfo([]))
            }
        },
        {
            name: 'Mutual Fund',
            path: `/${initialRouter[0]}/${initialRouter[1]}/${initialRouter[2]}`,
            state: {
                clientCode
            },
            warning: selectedSchemes?.length > 0 && !(pathname.split('/')[pathname.split('/').length - 1] === 'invest-more'),
            search: pathname.split('/')[pathname.split('/').length - 1] === 'invest-more' ? "?tab=Holdings" : "",
            handleClick: () => {
                if (!(pathname.split('/')[pathname.split('/').length - 1] === 'invest-more')) dispatch(setSelectedAllHoldingsInfo([]))
            }
        },
        ...(pathname.split('/')[pathname.split('/').length - 1] === 'invest-more' ? [
        ] : [
            {
                name: 'Explore Mutual Funds',
                path: `/${initialRouter[0]}/${initialRouter[1]}/${initialRouter[2]}/${initialRouter[3]}`,
                state: {
                    clientCode
                },
            },
            ...(initialRouter.includes('selected-category-funds') ? [{
                name: 'Selected Category Funds',
                path: `/${initialRouter[0]}/${initialRouter[1]}/${initialRouter[2]}/${initialRouter[3]}/${initialRouter[4]}`,
                state: {
                    clientCode,
                }
            }] : [])
        ]),
        {
            name: pathname.split('/')[pathname.split('/').length - 1] === 'invest-more' ? "Invest More" : 'Investment Details',
            path: `/${initialRouter[0]}/${initialRouter[1]}/${initialRouter[2]}/${initialRouter[3]}/${initialRouter[4]}`,
        },
    ] : [])

    const investorRouterPath = [
        {
            name: 'Dashboard' + `${selectedPortfolio.label ? ` (${selectedPortfolio.label})` : ''}`,
            path: '/investor-dashboard',
            warning: selectedSchemes?.length > 0,
            handleClick: () => {
                dispatch(setSelectedAllHoldingsInfo([]))
            }
        },
        {
            name: 'Mutual Funds',
            path: `/${initialRouter[0]}/${initialRouter[1]}`,
            state: {
                clientCode
            },
            warning: selectedSchemes?.length > 0 && !(pathname.split('/')[pathname.split('/').length - 1] === 'invest-more'),
            search: pathname.split('/')[pathname.split('/').length - 1] === 'invest-more' ? "?tab=Holdings" : "",
            handleClick: () => {
                if (!(pathname.split('/')[pathname.split('/').length - 1] === 'invest-more')) dispatch(setSelectedAllHoldingsInfo([]))
            }
        },
        ...(pathname.split('/')[pathname.split('/').length - 1] === 'invest-more' ? [
        ] : [
            {
                name: 'Explore Mutual Funds',
                path: `/${initialRouter[0]}/${initialRouter[1]}/${initialRouter[2]}`,
                state: {
                    clientCode
                },
            },
            ...(initialRouter.includes('selected-category-funds') ? [{
                name: 'Selected Category Funds',
                path: `/${initialRouter[0]}/${initialRouter[1]}/${initialRouter[2]}/${initialRouter[3]}`,
                state: {
                    clientCode,
                }
            }] : [])
        ]),

        {
            name: pathname.split('/')[pathname.split('/').length - 1] === 'invest-more' ? "Invest More" : 'Investment Details',
            path: `/${initialRouter[0]}/${initialRouter[1]}/${initialRouter[2]}/${initialRouter[3]}`,
            state: {
                clientCode
            }
        },
    ]


    const handleConformOrder = async () => {
        const selectedBankDetailsObj = (bankAccountList?.bankDetails ?? [])?.find(obj => `${obj?.bankAccNo ?? ""}` === `${formRef.current?.values?.bankAccountNumber ?? ""}`)

        try {
            setApiLoading('order')

            const payload = [...formRef.current?.values?.fund].map((item, i) => {
                return {
                    "clientCode": clientInterfaceCode ? clientInterfaceCode : clientCode,
                    "fromScheme": item.schemeId,
                    "schemeName": item.fundName,
                    "mobile": userDetails?.mobile,
                    "email": userDetails?.email,
                    amcId: item.fundAmcId,
                    folio: item?.activeTab === "Lumpsum" ? item?.lumpsum?.lumpsumFolio : item?.sip?.sipFolio,
                    ...((item?.sip === null || item?.sip?.sipamount === "" || item?.sip === undefined) ? {
                        amount: item?.lumpsum?.lumpAmount,
                        trType: "FRESH",
                        ...(pathname.split('/')[pathname.split('/').length - 1] !== 'invest-more' ? {} : {
                            folio: item?.folio?.folioId,
                            trType: "ADDITIONAL",
                            investedValue: folio?.[i].investedValue,
                            marketValue: folio?.[i].marketValue,
                        }),
                        bankName: selectedBankDetailsObj?.bankname ?? "",
                        bankAccountNumber: formRef.current?.values?.bankAccountNumber ?? "",
                        bankIfsc: selectedBankDetailsObj?.ifscCode ?? ""
                    } : {
                        trType: "XSIP",
                        transactionStartDate: dayjs(item?.sip?.sipDate).format("DD/MM/YYYY"),
                        mandateId: item?.sip?.mandate,
                        noOfInstallments: (`${item?.sip?.periods ?? ""}`.toUpperCase() === 'DAILY') ? '0' : item?.sip?.installments,
                        transactionEndDate: (`${item?.sip?.periods ?? ""}`.toUpperCase() === 'DAILY') ? dayjs(item?.sip?.sipEndDate).format("DD/MM/YYYY") : "",
                        frequency: item?.sip?.periods,
                        amount: item?.sip?.sipamount,
                        firstOrderFlag: item?.sip?.firstOrder ? "Y" : "N",
                        ...(pathname?.split('/')[pathname?.split('/')?.length - 1] !== 'invest-more' ? {} : {
                            folio: item?.folio?.folioId,
                            investedValue: folio?.[i].investedValue,
                            marketValue: folio?.[i].marketValue,
                        }),
                        bankName: selectedBankDetailsObj?.bankname ?? "",
                        bankAccountNumber: formRef.current?.values?.bankAccountNumber ?? "",
                        bankIfsc: selectedBankDetailsObj?.ifscCode ?? ""
                    }),
                    portfolioId: selectedPortfolio?.value,
                    portfolioName: selectedPortfolio?.label,
                    rmId: `${investorRmId}`,
                    "cartId": null,
                    "isRecommended": true,
                    "isDiy": false,

                }
            })


            const res = await dispatch(submitInvestmentDetails({
                accountType: selectedPortfolioObj?.portfolioAccountType,
                orderDetails: payload,
                ...((![USER_ROLES.INVESTOR].includes(role)) ? {
                    documents: formRef?.current?.values?.documents?.filter((obj: {
                        documentId: string;
                        documentType: string;
                    }) => obj.documentId !== "" && obj.documentType !== "")
                } : {})
            })) as unknown as {
                isSuccess: boolean,
                message: string,
                ordersValidation: Array<any>
            };

            if (res.isSuccess) {
                setRecommendPlaceOrderResponse(res)

                setConfirmRecomment(false)
                dispatch(setSelectedHoldingsIds([]))
                dispatch(setCheckedHoldingSchemes([]))
                dispatch(setSelectedHoldingsInfo([]))
                dispatch(setSelectedAllHoldingsInfo([]))

                setSuccessModal(true);
            } else if (!res.isSuccess) {
                setConfirmRecomment(false)
                if (res?.ordersValidation.length > 0) {
                    setValidationErrorsArray(
                        res?.ordersValidation
                            .filter(data => !data.isSuccess)
                            .map(data => ({
                                schemeName: data?.schemeName,
                                errorMessage: data?.message
                            }))
                    )
                    setValidationDialogVisible(true)
                }
            }
        } catch (error) {
            console.log('error', error);
        } finally {
            setConfirmRecomment(false);
            setRiskProfilePopup(false);
            setApiLoading("")
        }
    };

    const handleConfromRecomment = async () => {
        try {
            setApiLoading("recomment")

            const selectedBankDetailsObj = (bankAccountList?.bankDetails ?? [])?.find(obj => `${obj?.bankAccNo ?? ""}` === `${formRef.current?.values?.bankAccountNumber ?? ""}`)


            const payload = [...formRef.current?.values?.fund].map((item, i) => {
                return {
                    clientCode: clientInterfaceCode ? clientInterfaceCode : clientCode,
                    amcId: item.fundAmcId,
                    schemeId: item.schemeId,
                    schemeName: item.fundName,
                    categoryName: item.fundType,
                    subCategoryName: item.fundCap,
                    riskType: item.riskType,
                    aumAmount: item.detailsList[0].value,
                    navValue: item.detailsList[1].value,
                    y3Returns: item.detailsList[2].value,
                    exitLoad: item.detailsList[3].value,
                    investedValue: 0,
                    marketValue: 0,
                    recommendedDate: dayjs().format("DD/MM/YYYY"),
                    imgUrl: item.fundImage,
                    folioNo: item?.activeTab === "Lumpsum" ? item?.lumpsum?.lumpsumFolio : item?.sip?.sipFolio,
                    ...(item?.sip === null || item?.sip?.sipamount === '' || item?.sip === undefined ? {
                        buySellType: "LUMPSUM",
                        recommendedAmount: `${item.lumpsum?.lumpAmount}`,
                        ...(pathname.split('/')[pathname.split('/').length - 1] !== 'invest-more' ? {} : {
                            folioNo: item?.folio?.folioId,
                            investedValue: folio?.[i].investedValue,
                            marketValue: folio?.[i].marketValue,
                        }),
                        bankName: selectedBankDetailsObj?.bankname ?? "",
                        bankAccountNumber: formRef.current?.values?.bankAccountNumber ?? "",
                        bankIfsc: selectedBankDetailsObj?.ifscCode ?? ""
                    } : {
                        buySellType: "XSIP",
                        mandateId: item?.sip?.mandate,
                        noOfInstallments: (`${item?.sip?.periods ?? ""}`.toUpperCase() === 'DAILY') ? '0' : `${item?.sip?.installments}`,
                        systematicDate: dayjs(item?.sip?.sipDate).format("DD/MM/YYYY"),
                        endDate: (`${item?.sip?.periods ?? ""}`.toUpperCase() === 'DAILY') ? dayjs(item?.sip?.sipEndDate).format("DD/MM/YYYY") : "",
                        frequency: item?.sip?.periods,
                        recommendedAmount: `${item?.sip?.sipamount}`,
                        firstOrderFlag: item?.sip?.firstOrder ? "Y" : "N",
                        ...(pathname.split('/')[pathname.split('/').length - 1] !== 'invest-more' ? {} : {
                            folioNo: item?.folio?.folioId,
                            investedValue: folio?.[i].investedValue,
                            marketValue: folio?.[i].marketValue,
                        }),
                        bankName: selectedBankDetailsObj?.bankname ?? "",
                        bankAccountNumber: formRef.current?.values?.bankAccountNumber ?? "",
                        bankIfsc: selectedBankDetailsObj?.ifscCode ?? ""
                    }),
                    portfolioId: selectedPortfolio?.value,
                    rmId: `${investorRmId}`
                }
            })



            const res = (await dispatch(submitRecomment(payload))) as unknown as {
                isSuccess: boolean,
                message: string,
                response: Array<any>
            };

            if (res.isSuccess) {
                setRecommendPlaceOrderResponse(res)

                setConfirmRecomment(false)
                dispatch(setSelectedHoldingsIds([]))
                dispatch(setCheckedHoldingSchemes([]))
                dispatch(setSelectedHoldingsInfo([]))
                dispatch(setSelectedAllHoldingsInfo([]))

                setSuccessModal(true);
            } else if (!res.isSuccess) {
                setConfirmRecomment(false)
                if (res?.response.length > 0) {
                    setValidationErrorsArray(
                        res.response
                            .filter(data => !data.isSuccess)
                            .map(data => ({
                                schemeName: data.schemeName,
                                errorMessage: data.message
                            }))
                    )
                    setValidationDialogVisible(true)
                }
            }
        } catch (error) {
            console.log("Error: ", error)
        } finally {
            setApiLoading("");
        }
    }

    const handleRiskProfilePopup = (btnText: string) => {
        setRiskProfilePopup(false);

        if (btnText === 'continue') {
            setConfirmRecomment(true);
        }
    }

    const handleSuccess = () => {
        history.push('/cart', { clientCode })
    }

    const handleSuccessPopup = () => {
        dispatch(setAppliedFundsFilters([]));
        dispatch(setSelectedSchemesObj({}));

        if (role === USER_ROLES.INVESTOR) {
            history.push('/investor-dashboard')
        } else {
            history.push('/dashboard')
        }
    }

    const handleCloseFiveSchemesDialog = () => {
        setFiveSchemesDialogVisible(false)
    }

    const handleValidationDialogClose = () => {
        setValidationDialogVisible(false)
    }


    const hasDuplicateSchemes = (arr: any) => {
        const codeSet = new Set();

        for (const item of arr) {
            const key = `${item?.isinCode ?? ""}-${item?.folio?.folioId ?? ""}`;
            if (codeSet.has(key)) {
                return true;
            }
            codeSet.add(key);
        }

        return false;
    }

    const handleSameSchemeDialogClose = () => {
        setSameSchemesDialogOpen(false)
    }

    const handleSameSchemeDialogConfirm = async () => {
        handleSameSchemeDialogClose()

        if (!formRef.current) {
            return
        }

        if (orderType === 'investor') {

            const selectedBankDetailsObj = (bankAccountList?.bankDetails ?? [])?.find(obj => `${obj?.bankAccNo ?? ""}` === `${formRef.current?.values?.bankAccountNumber ?? ""}`)

            try {
                setApiLoading("investor");
                const payload = [...formRef.current?.values?.fund].map((item, i) => {
                    return {
                        categoryName: item.fundType,
                        isDividendReinvestment: item?.divReinvestAllowed ?? "",
                        mPowerScheme: item?.mPowerScheme ?? "",
                        clientCode: clientInterfaceCode ? clientInterfaceCode : clientCode,
                        navValue: item.detailsList[1].value,
                        y3Returns: item.detailsList[2].value,
                        exitLoad: item.detailsList[3].value,
                        aumAmount: item.detailsList[0].value,
                        riskType: item.riskType,
                        schemeId: item.schemeId,
                        schemeName: item.fundName,
                        subCategoryName: item.fundCap,
                        isRecommended: false,
                        navDate: item.detailsList[1].title.slice(5),
                        folioNo: item?.activeTab === "Lumpsum" ? item?.lumpsum?.lumpsumFolio : item?.sip?.sipFolio,
                        trType: (item?.sip === null || item?.sip?.sipamount === "" || item?.sip === undefined) ? (
                            isInvestMore ?
                                "ADDITIONAL" :
                                `${item?.lumpsum?.lumpsumFolio ?? ""}`.toLowerCase() === "new folio" ? "FRESH" : "ADDITIONAL"
                        ) : 'SIP',
                        investedValue: "0",
                        marketValue: "0",
                        amcId: item.fundAmcId,
                        ...((item?.sip === null || item?.sip?.sipamount === "" || item?.sip === undefined) ? {
                            amount: item?.lumpsum?.lumpAmount,
                            ...(pathname.split('/')[pathname.split('/').length - 1] !== 'invest-more' ? {} : {
                                folioNo: item?.folio?.folioId,
                                investedValue: `${folio?.[i]?.investedValue}`,
                                marketValue: `${folio?.[i]?.marketValue}`,
                            }),
                            bankName: selectedBankDetailsObj?.bankname ?? "",
                            bankAccountNumber: formRef.current?.values?.bankAccountNumber ?? "",
                            bankIfsc: selectedBankDetailsObj?.ifscCode ?? "",
                        } : {
                            amount: item?.sip?.sipamount,
                            mandateId: item?.sip?.mandate,
                            frequency: item?.sip?.periods,
                            noOfInstallment: (`${item?.sip?.periods ?? ""}`.toUpperCase() === 'DAILY') ? 0 : item?.sip?.installments,
                            sipDate: dayjs(item?.sip?.sipDate).format("DD/MM/YYYY"),
                            endDate: (`${item?.sip?.periods ?? ""}`.toUpperCase() === 'DAILY') ? dayjs(item?.sip?.sipEndDate).format("DD/MM/YYYY") : "",
                            firstOrderFlag: item?.sip?.firstOrder ? "Y" : "N",
                            ...(pathname.split('/')[pathname.split('/').length - 1] !== 'invest-more' ? {} : {
                                folioNo: item?.folio?.folioId,
                                investedValue: `${folio?.[i]?.investedValue}`,
                                marketValue: `${folio?.[i]?.marketValue}`,
                            }),
                            bankName: selectedBankDetailsObj?.bankname ?? "",
                            bankAccountNumber: formRef.current?.values?.bankAccountNumber ?? "",
                            bankIfsc: selectedBankDetailsObj?.ifscCode ?? "",
                        }),
                        portfolioId: selectedPortfolio?.value,
                        rmId: `${investorRmId}`,
                        transMode: 'A',
                    }
                })

                const res = ((await dispatch(addToCart(payload as any))) as unknown) as AddToCartResponseBody;
                if (res.isSuccess) {
                    setConfirmRecomment(false)
                    const { isSuccess, cartItemsCount } = await (dispatch(getCartItemsCount({
                        clientCode: clientInterfaceCode ? clientInterfaceCode : clientCode,
                        portfolioId: selectedPortfolio?.value
                    })) as unknown as Promise<GetCartItemsCountResponseBody>)

                    if (isSuccess) {
                        dispatch(setCartItemsCount(cartItemsCount));
                        dispatch(setSelectedHoldingsInfo([]))
                        dispatch(setSelectedAllHoldingsInfo([]))
                    }

                    setCartPopup(true)
                } else if (!res.isSuccess) {
                    setConfirmRecomment(false)
                    if (res.message) {
                        setFiveSchemesDialogVisible(true)
                    } else {
                        setValidationErrorsArray(
                            res.response
                                .filter(data => !data.isSuccess)
                                .map(data => ({
                                    schemeName: data.schemeName,
                                    errorMessage: data.message
                                }))
                        )
                        setValidationDialogVisible(true)
                    }
                }
            } catch (err) {
                console.log(err)
            } finally {
                setApiLoading("");
            }
        } else {
            if (orderType === 'order') {
                try {
                    setRiskPflChkLoading(true);
                    const riskProfileCheckRes = (await dispatch(getRiskProfileCheck({
                        clientCode: clientInterfaceCode ? clientInterfaceCode : clientCode,
                        schemeCode: (formRef.current?.values?.fund ?? [])?.map((item: any) => {
                            return item?.schemeId
                        })

                    }))) as unknown as {
                        isSuccess: boolean,
                        displayText: string
                    }

                    setRiskProfileCheckResponse(riskProfileCheckRes ?? {})

                    if (!riskProfileCheckRes?.isSuccess) {
                        setRiskProfilePopup(true)
                        setRiskPopupText(riskProfileCheckRes?.displayText || "Risk Profile Expired!")
                    } else if (riskProfileCheckRes?.isSuccess) {
                        if (`${riskProfileCheckRes?.displayText ?? ""}`.length > 0) {
                            setRiskProfilePopup(true)
                            setRiskPopupText(riskProfileCheckRes.displayText)
                        } else {
                            setConfirmRecomment(true)
                        }
                    }
                } catch (e) {
                    console.log(e);
                } finally {
                    setRiskPflChkLoading(false);
                }
            } else {
                setConfirmRecomment(true)
            }
        }
    }

    const newHandleSubmit = async (value: FormikValues) => {
        if ((
            ![USER_ROLES.INVESTOR].includes(role) &&
            orderType === "order"
        )) {
            if (value?.documents?.length === 1 && (value?.documents[0]?.documentId === '' || value?.documents[0]?.documentType === '')) {
                setDocumentUploadErrorDialogVisible(true)
                return
            }
        }

        if (isInvestMore) {

            // Checking if multiple orders with the same scheme/folio combination are there ot not

            const hasDuplicates = hasDuplicateSchemes(value?.fund ?? [])

            if (hasDuplicates) {
                setSameSchemesDialogOpen(true)
                return
            } else {
                handleSameSchemeDialogConfirm()
            }
        } else {
            handleSameSchemeDialogConfirm()
        }
    }

    const handleAddMore = () => {
        if (pathname.split('/').slice(-2)[0] === 'explore') {
            history.push(pathname.split('/').slice(0, -1).join('/'), { clientCode })
        } else {
            history.push(pathname.split('/').slice(0, -2).join('/'), { clientCode })
        }
    }

    const handleDelete = (id: number | string, checkId?: string, selectedUniqueId?: string) => {

        setDetails((pre: GETINVESTMENTDETAILTYPE) => {

            const result = pre?.investmentDetails?.filter((item) => item?.schemeId !== checkId);
            const result1 = pre?.investmentDetails?.filter((item) => item?.schemeId !== id);

            if (pathname.split('/')[pathname.split('/').length - 1] === 'invest-more') {

                const modifiedSelectedSchemes = selectedSchemes?.filter((item: any) => item.uniqueId !== selectedUniqueId);

                history.replace({
                    state: ({
                        selectedSchemes: modifiedSelectedSchemes,
                        clientCode,
                        schemeDetails: (modifiedSelectedSchemes ?? [])
                            .map(item => ({
                                scheme_id: item?.schemeId ?? "-",
                                isReinvestment: item?.isReinvest ?? "-"
                            })),
                        folio: (modifiedSelectedSchemes ?? [])
                            .map(item => ({
                                folioId: item.folioId,
                                schemeId: item.scheme,
                                id: item.id,
                                marketValue: item.marketValue,
                                investedValue: item.investedValue,
                            })),
                    })
                })
            } else {
                history.replace({ state: { selectedSchemes: selectedSchemes?.filter((item: any) => (item?.scheme ? item?.scheme : item) !== id), clientCode } })

                const modifiedSelectedSchemesObj = Object.fromEntries(Object.entries(selectedSchemesObj).filter(([key, _]) => key !== `${id}`))

                dispatch(setSelectedSchemesObj(modifiedSelectedSchemesObj))

            }

            return { ...pre, investmentDetails: pathname.split('/')[pathname.split('/').length - 1] === 'invest-more' ? result : result1 };
        })
    }

    const handleAddMoreProceed = () => {
        if (pathname.split('/')[pathname.split('/').length - 1] === 'invest-more') {
            history.replace({ state: ({ selectedSchemes: radioValue.map((obj: any) => (obj?.scheme || obj)), clientCode }) })

            dispatch(setSelectedHoldingsIds(radioValue.map((obj: any) => (obj?.scheme || obj))))

            addFunds(radioValue?.map((obj: any) => (obj?.scheme || obj)))
        } else {
            history.replace({ state: ({ selectedSchemes: radioValue, clientCode }) })

            const selectedSchemesObj = radioValue.reduce((acc: any, obj: any) => {
                acc[obj.scheme] = {
                    ...obj,
                    scheme: `${obj.scheme}`,
                    checked: obj.checked ? obj.checked : true,
                };
                return acc;
            }, {});
            dispatch(setSelectedSchemesObj(selectedSchemesObj))

            addFunds(selectedSchemesObj)
        }
        setOpen(false);

    }

    const addFunds = async (schemes: any, addedFolio?: any) => {
        try {
            if (isInvestMore) {

                // schemes currently in formik
                const currentSchemesArr = (formRef.current?.values?.fund ?? []).map((obj: any) => ({ uniqueId: obj?.uniqueId ?? "" }))

                // latest added schemes excluding the schemes in formik
                const latestAddedSchemes = schemes?.filter((obj: any) => !currentSchemesArr.find((currObj: any) => currObj.uniqueId === obj.uniqueId))

                if (!(latestAddedSchemes ?? []).length) {
                    return
                }

                setIsLoading(true);

                const payload = {
                    // passing only those schemeIds which have been added via Add more funds, NOT passing those schemes already in Formik
                    schemeIds: (latestAddedSchemes ?? [])?.map((item: any) => item?.scheme ?? ""),
                    portfolioId: selectedPortfolio?.value,
                    clientCode: clientCode,
                    rmId: `${investorRmId}`,
                    schemeDetails: (latestAddedSchemes ?? [])?.map((obj: any) => ({
                        scheme_id: obj?.scheme ?? "",
                        isReinvestment: obj?.isReinvestment ? obj?.isReinvestment ?? "" : obj?.divReinvestAllowed ?? "",
                    }))
                }

                const res = (await dispatch(getInvestmentDetails(payload))) as GETINVESTMENTDETAILTYPE | unknown
                setDetails(res as GETINVESTMENTDETAILTYPE);

                // extracting ISIN codes from the response
                const responseIsinCodes = ((res as GETINVESTMENTDETAILTYPE)?.investmentDetails ?? []).map((item: any) => item.isinCode) as Array<string>

                // Filtering out those schemes for which we did not get the api response based on the isin code
                const modifiedLatestAddedSchemes = latestAddedSchemes.filter((item: any) => responseIsinCodes.includes(item.isinCode));

                const formInitial = [...(res as GETINVESTMENTDETAILTYPE)?.investmentDetails ?? []].map((item, i) => {

                    const addedFolio = {
                        folioId: modifiedLatestAddedSchemes[i].folioId,
                        schemeId: modifiedLatestAddedSchemes[i].scheme,
                        id: modifiedLatestAddedSchemes[i].id,
                        marketValue: modifiedLatestAddedSchemes[i].marketValue,
                        investedValue: modifiedLatestAddedSchemes[i].investedValue,
                    }

                    const currentFrequency = item?.frequencies?.filter((freq) => freq.tranasactionType === 'SIP')[0]?.frequency || ''

                    const sipValidations = item?.validations?.filter((freq: any) => freq?.transactionType === 'SIP')

                    const currentFrequencyValidation = (sipValidations ?? []).filter((obj: any) => `${obj?.frequency ?? ""}`.toLowerCase() === `${currentFrequency ?? ""}`.toLowerCase())

                    const investmentDates = currentFrequencyValidation?.[0]?.investmentDates || [];

                    return {
                        ...item,
                        sip: {
                            sipamount: '',
                            periods: currentFrequency,
                            installments: '',
                            sipDate: findNextValidDate(investmentDates, true),
                            sipEndDate: '',
                            mandate: activeMandateList[0]?.mandateId || '',
                            sipFolio: item?.folios?.availableFolios[0] || '',
                            firstOrder: true,
                        },
                        lumpsum: {
                            lumpAmount: '',
                            lumpsumFolio: item?.folios?.availableFolios[0] || '',
                        },
                        activeTab: 'Lumpsum',
                        schemeId: item?.schemeId,
                        mandate: activeMandateList,
                        folio: addedFolio,
                        uniqueId: modifiedLatestAddedSchemes?.[i]?.uniqueId ?? ""
                    }
                })

                const currentForm = [...formRef.current?.values.fund]

                const updatedFundsArray = [...currentForm, ...formInitial]

                history.replace({
                    state: ({
                        selectedSchemes: [...(selectedSchemes ?? []), ...(modifiedLatestAddedSchemes ?? [])]
                            .map((item: any) => ({
                                ...item,
                                folioId: item.folioNo,
                                scheme: item.schemeId,
                                id: item.id,
                                marketValue: item.marketValue,
                                investedValue: item.investedValue,
                                isReinvestment: item?.isReinvest
                            })),
                        clientCode,
                        schemeDetails: [...(selectedSchemes ?? []), ...(modifiedLatestAddedSchemes ?? [])]
                            .map((item: any) => ({
                                scheme_id: item?.schemeId ?? "-",
                                isReinvestment: item?.isReinvest ?? "-"
                            })),
                        folio: [...(selectedSchemes ?? []), ...(modifiedLatestAddedSchemes ?? [])]
                            .map((item: any) => ({
                                folioId: item.folioId,
                                schemeId: item.scheme,
                                id: item.id,
                                marketValue: item.marketValue,
                                investedValue: item.investedValue,
                            }))
                    })
                })

                dispatch(setSelectedHoldingsInfo(
                    [...(selectedSchemes ?? []), ...(modifiedLatestAddedSchemes ?? [])].map(obj => ({
                        checkedId: obj?.id,
                        schemeId: obj?.scheme,
                        folioNo: obj?.folioNo ?? "",
                        uniqueId: obj?.uniqueId
                    }))))

                dispatch(setSelectedAllHoldingsInfo([...(selectedSchemes ?? []), ...(modifiedLatestAddedSchemes ?? [])]))

                formRef.current?.resetForm({
                    values: {
                        fund: updatedFundsArray,
                        ...((
                            ![USER_ROLES.INVESTOR].includes(role)
                        ) ? {
                            documents: formRef.current?.values?.documents ?? []
                        } : {}),
                        bankAccountNumber: formRef.current?.values?.bankAccountNumber ?? ""
                    }
                })
            } else {
                if (!Object.keys(schemes ?? {}).length) {

                    formRef.current?.resetForm({
                        values: {
                            fund: [],
                            ...((![USER_ROLES.INVESTOR].includes(role)) ? {
                                documents: formRef.current?.values?.documents ?? []
                            } : {}),
                            bankAccountNumber: formRef.current?.values?.bankAccountNumber ?? ""
                        }
                    })

                    return
                }

                setIsLoading(true);
                const payload = {
                    schemeIds: Object.values(schemes)?.map((item: any) => item?.scheme ? item?.scheme : item),
                    portfolioId: selectedPortfolio?.value,
                    clientCode: clientCode,
                    rmId: `${investorRmId}`,
                    schemeDetails: Object.values(schemes)?.map((obj: any) => ({
                        scheme_id: obj?.scheme ?? "",
                        isReinvestment: obj?.isReinvestment ? obj?.isReinvestment ?? "" : obj?.divReinvestAllowed ?? "",
                    }))
                }

                const res = (await dispatch(getInvestmentDetails(payload))) as GETINVESTMENTDETAILTYPE | unknown
                setDetails(res as GETINVESTMENTDETAILTYPE);
                const formInitial = [...(res as GETINVESTMENTDETAILTYPE)?.investmentDetails ?? []].map((item, i) => {

                    const currentFrequency = item?.frequencies?.filter((freq) => freq.tranasactionType === 'SIP')[0]?.frequency || ''

                    const sipValidations = item?.validations?.filter((freq: any) => freq?.transactionType === 'SIP')

                    const currentFrequencyValidation = (sipValidations ?? []).filter((obj: any) => `${obj?.frequency ?? ""}`.toLowerCase() === `${currentFrequency ?? ""}`.toLowerCase())

                    const investmentDates = currentFrequencyValidation?.[0]?.investmentDates || [];

                    return {
                        ...item,
                        sip: {
                            sipamount: '',
                            periods: currentFrequency,
                            installments: '',
                            sipDate: findNextValidDate(investmentDates, true),
                            sipEndDate: '',
                            mandate: activeMandateList[0]?.mandateId || '',
                            sipFolio: item?.folios?.availableFolios[0] || '',
                            firstOrder: true,
                        },
                        lumpsum: {
                            lumpAmount: '',
                            lumpsumFolio: item?.folios?.availableFolios[0] || '',
                        },
                        activeTab: 'Lumpsum',
                        schemeId: item?.schemeId,
                        mandate: activeMandateList,
                        folio: addedFolio?.[i],
                    }
                })

                const currentForm = [...formRef.current?.values.fund]
                const newFrom = [...formInitial]

                const getSchemeId = (item: any) => item?.map((obj: any) => obj.schemeId)

                const currentSchemeId = getSchemeId([...currentForm])
                const newSchemeId = getSchemeId([...newFrom])

                const filteredNewData = newFrom.filter((item: any) => !currentSchemeId.includes(item.schemeId))
                const filteredCurrentForm = currentForm.filter((item: any) => newSchemeId.includes(item.schemeId))

                formRef.current?.resetForm({
                    values: {
                        fund: [...filteredCurrentForm, ...filteredNewData],
                        ...((![USER_ROLES.INVESTOR].includes(role)) ? {
                            documents: formRef.current?.values?.documents ?? []
                        } : {}),
                        bankAccountNumber: formRef.current?.values?.bankAccountNumber ?? ""
                    }
                })
            }
        } catch (err) {
            console.log('error', err)
        } finally {
            setIsLoading(false)
        }
    };

    const handleAddMoreChangeRadion = (data: any) => {
        setRadioValue(((pre: any) => {

            const remining = pre.filter((item: any) => (item?.scheme || item) === data.scheme)

            if (pre.length >= MAX_SCHEMES_SELECTED && !remining.length) {
                setWarning(true)
                return pre
            }
            if (remining.length === 0) {
                return [...pre, data]
            } else if (remining.length > 0) {
                return pre.filter((item: any) => (item?.scheme || item) !== data.scheme)
            }
        }));
    };

    const handleProceed = () => {
        const data = selectAllHoldingsInfo.map(item => ({
            ...item,
            folioId: item.folioNo,
            scheme: item.schemeId,
            id: item.id,
            marketValue: item.marketValue,
            investedValue: item.investedValue,
            isReinvestment: item?.isReinvest
        }))

        const checkedIds = data.map((obj) => obj.scheme)

        const folioData = data.map((obj) => ({
            folioId: obj.folioId,
            schemeId: obj.scheme,
            id: obj.id,
            marketValue: obj.marketValue,
            investedValue: obj.investedValue
        }))

        dispatch(setSelectedHoldingsIds([...[]]))
        dispatch(setCheckedHoldingSchemes([...checkedIds]))

        setOpen(false)

        addFunds([...data], folioData)
    }

    const handleDocumentUploadDialogOpen = () => {
        setDocumentUploadDialogVisible(true)
    }

    const handleDocumentUploadDialogClose = () => {
        setDocumentUploadDialogVisible(false)
    }

    const handleDocumentUploadErrorDialogClose = () => {
        setDocumentUploadErrorDialogVisible(false)
    }

    const handleSelectBankAccount = async (event: SelectChangeEvent<any>) => {
        try {
            if (!formRef.current) return

            setBankBalanceObjLoading(true)

            const { setFieldValue } = formRef.current ?? {}

            setFieldValue('bankAccountNumber', event.target.value);

            setBankBalanceObj({} as GetBankBalanceResponseBody)

            const response = await (dispatch(getBankBalance({
                investorBankAccount: event.target.value,
                clientCode: `${clientCode ?? ""}`,
                investorIfscCode: (bankAccountList?.bankDetails ?? [])?.find((item: any) => item?.bankAccNo === event.target.value)?.ifscCode ?? ""
            })) as unknown as Promise<GetBankBalanceResponseBody>);

            if (!response?.isSuccess) {
                dispatch(showError(response?.message ?? "No Data Available"))
            }

            setBankBalanceObj(response)
        } catch (error) {
            console.log("Error: ", error)
        } finally {
            setBankBalanceObjLoading(false)
        }
    }

    let successMessage = ""

    if (orderType === 'recomment') {
        successMessage = "Your Recommendation is sent successfully to the Investor."
    } else {
        if (ENABLE_MF_TRANSACTIONS_POA_DOCUMENT_UPLOAD && selectedPortfolioObj?.portfolioAccountType) {
            if (![USER_ROLES.INVESTOR].includes(role) &&
                [
                    MPOWER_ACCOUNT_TYPE_MASTER[MPOWER_ACCOUNT_TYPE_MASTER.ADVISORY],
                    MPOWER_ACCOUNT_TYPE_MASTER[MPOWER_ACCOUNT_TYPE_MASTER.POA]
                ].includes(MPOWER_ACCOUNT_TYPE_MASTER[`${selectedPortfolioObj?.portfolioAccountType ?? ""}`?.toUpperCase()])) {
                successMessage = `Your order${(recommendPlaceOrderResponse?.status_responses ?? [])?.length > 1 ? "s" : ""} with order ID${(recommendPlaceOrderResponse?.status_responses ?? [])?.length > 1 ? "s" : ""} ${(recommendPlaceOrderResponse?.status_responses ?? [])?.map((obj: any) => obj?.id)?.join(', ')} ${(recommendPlaceOrderResponse?.status_responses ?? [])?.length > 1 ? "are" : "is"} sent to the checker for approval.`
            }
            if (![USER_ROLES.INVESTOR].includes(role) &&
                MPOWER_ACCOUNT_TYPE_MASTER[selectedPortfolioObj?.portfolioAccountType?.toUpperCase()] ===
                MPOWER_ACCOUNT_TYPE_MASTER["EXY"]
            ) {
                successMessage = `Your order${(recommendPlaceOrderResponse?.status_responses ?? [])?.length > 1 ? "s" : ""} with order ID${(recommendPlaceOrderResponse?.status_responses ?? [])?.length > 1 ? "s" : ""} ${(recommendPlaceOrderResponse?.status_responses ?? [])?.map((obj: any) => obj?.id)?.join(', ')} ${(recommendPlaceOrderResponse?.status_responses ?? [])?.length > 1 ? "are" : "is"} sent to the checker for approval.`
            }
        } else {
            successMessage = "The transaction link will be sent via email by BSE Star for authorisation and completion of the transaction."
        }

    }

    const isMinor = isOnboardingTypeMinor(userDetails?.application?.onboardingType || '');
    const investorName = isMinor ? `${userDetails?.application?.applicants?.[0]?.minorFirstName} ${userDetails?.application?.applicants?.[0]?.minorLastName}` : userDetails?.name;

    return (
        <>
            <BreadCrum array={![USER_ROLES.INVESTOR].includes(role) ? rmRouterPath : investorRouterPath} />
            <Typography variant="h1" color={palette.text.primary} fontSize={{ sm: '16px', xs: '16px', md: '24px', lg: '24px' }} mt={2}>
                {pathname.split('/')[pathname.split('/').length - 1] === 'invest-more' ? "Invest More" : 'Investment Details'}
            </Typography>
            <Formik
                innerRef={formRef}
                enableReinitialize
                initialValues={formInitialData}
                validationSchema={investmentDetailsSchema}
                onSubmit={newHandleSubmit}>
                {(formik) => {

                    const selectedBankObj = (bankAccountList?.bankDetails ?? []).find(obj => obj?.bankAccNo === formik.values?.bankAccountNumber)

                    return (
                        <>
                            <Box component="form" onSubmit={formik.handleSubmit}>
                                <Grid container marginTop={2} spacing={2}>
                                    <Grid item lg={8} md={12} sm={12} xs={12} sx={{ display: 'flex', rowGap: '25px', flexDirection: 'column' }}>
                                        <>
                                            <FieldArray
                                                name='fund'
                                                render={(arrayhelper) => {
                                                    return (formik.values.fund)?.map((_data: FormikValues, index: number) => (
                                                        <Card key={index} {...{ isLoading, id: index, arrayhelper, handleDelete, clientCode, activeMandateList, folio: folio as any, selectedSchemes: selectedSchemes?.map((item: any) => item?.scheme ? item?.scheme : item), isSubmitting: !!apiLoading, bankAccountList, isBankBalanceObjLoading }} />
                                                    ))
                                                }
                                                }
                                            />
                                            {selectedSchemes.length < MAX_SCHEMES_SELECTED && (
                                                <Box
                                                    component={'div'}
                                                    sx={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
                                                    {
                                                        isLoading ?
                                                            <Skeleton variant="rectangular" width={200} height={30} /> :
                                                            <Hidden only={'xs'}>
                                                                <Button
                                                                    variant="text"
                                                                    onClick={() => setOpen(true)}
                                                                    sx={{
                                                                        gap: '10px',
                                                                        '&:hover': {
                                                                            background: 'transparent',
                                                                        },
                                                                        '&:disabled': {
                                                                            opacity: 0.5
                                                                        }
                                                                    }}
                                                                    disabled={!!apiLoading || riskPflChkLoading || isBankBalanceObjLoading}
                                                                >
                                                                    <BluePlusIcon />
                                                                    <Typography
                                                                        variant="body_500"
                                                                        color={palette.text.secondary}
                                                                        sx={{
                                                                            textDecoration: 'dashed',
                                                                            textDecorationColor: palette.primary[500],
                                                                            textDecorationThickness: '2px',
                                                                        }}>
                                                                        {pathname.split('/')[pathname.split('/').length - 1] === 'invest-more' ? "Add More Holding" : "Add More Funds"}

                                                                    </Typography>
                                                                </Button>
                                                            </Hidden>}
                                                    <Hidden smUp={true}>
                                                        {isLoading ?
                                                            <Skeleton variant="rectangular" width={200} height={20} /> :
                                                            <Box
                                                                component={'button'}
                                                                onClick={() => handleAddMore()}
                                                                sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: '15px', justifyContent: 'center', borderRadius: '10px', border: `1px solid ${palette.primary[500]}`, maxWidth: '271px', width: '100%', height: '49px', cursor: 'pointer', background: 'transparent' }}
                                                                disabled={isBankBalanceObjLoading}
                                                            >
                                                                <BluePlusIcon />
                                                                <Typography variant="body_500" fontFamily={typography.fontFamily} color={palette.primary[500]} sx={{ textDecoration: 'dashed', textDecorationColor: palette.primary[500], textDecorationThickness: '1px', textDecorationLine: 'underline' }}>
                                                                    Add More Funds
                                                                </Typography>
                                                            </Box>}
                                                    </Hidden>
                                                </Box>
                                            )}
                                        </>
                                    </Grid>
                                    <Grid item lg={4} md={12} sx={{ width: '100%' }}>
                                        {(![USER_ROLES.INVESTOR].includes(role)) && (
                                            <Box
                                                sx={{
                                                    background: palette.background.paper,
                                                    padding: '20px',
                                                    borderRadius: '20px',
                                                    marginBottom: "20px",
                                                    display: "flex",
                                                    justifyContent: "center",
                                                    alignItems: "center",
                                                    flexDirection: "column"
                                                }}
                                                boxShadow={1}
                                            >
                                                <Typography
                                                    variant="body_500"
                                                    sx={{
                                                        lineHeight: "20px",
                                                        letterSpacing: "0.02px",
                                                        color: `${palette.text.secondary}B2`,
                                                    }}
                                                >
                                                    You can add minimum 1 attachment and maximum 5 attachments for placing order
                                                </Typography>
                                                <Typography
                                                    variant='body_400'
                                                    sx={{
                                                        color: palette.text.primary,
                                                        alignSelf: "flex-start",
                                                        marginTop: "10px"
                                                    }}
                                                >
                                                    Documents Uploaded: {
                                                        (formik?.values?.documents ?? [])?.filter((obj: {
                                                            documentId: string;
                                                            documentType: string;
                                                        }) => obj.documentId !== "" && obj.documentType !== "")?.length ?? "0"
                                                    }
                                                </Typography>
                                                <Button
                                                    sx={{
                                                        ...typography.body_500,
                                                        color: palette.primary[500],
                                                        padding: "5px",
                                                        fontWeight: 600,
                                                        marginTop: "15px"
                                                    }}
                                                    onClick={handleDocumentUploadDialogOpen}
                                                    disabled={isLoading || !!apiLoading || isBankBalanceObjLoading}
                                                >
                                                    Upload Documents
                                                </Button>
                                            </Box>
                                        )}
                                        <Box
                                            sx={{
                                                background: palette.background.paper,
                                                padding: '20px',
                                                borderRadius: '20px',
                                                marginBottom: "20px",
                                                display: "flex",
                                                flexDirection: "column",
                                                rowGap: "15px"
                                            }}
                                            boxShadow={1}
                                        >
                                            <Box sx={{ width: "100%" }}>
                                                <CustomeBlueDropDown
                                                    isLoading={isLoading || isBankBalanceObjLoading}
                                                    label='Select Bank Account'
                                                    disabled={!!apiLoading}
                                                    name="bankAccountNumber"
                                                    list={(bankAccountList?.bankDetails ?? [])?.map(
                                                        (obj: BankDetails) => ({
                                                            label: `${obj?.bankAccNo} ${obj?.bankname} ${BANK_SUB_ACCOUNT_TYPES[`${obj?.subAccountType ?? ""}`.toUpperCase()] ? "(" + BANK_SUB_ACCOUNT_TYPES[`${obj?.subAccountType ?? ""}`.toUpperCase()] + ")" : ""}`,
                                                            value: obj?.bankAccNo
                                                        })
                                                    )}
                                                    onChange={handleSelectBankAccount}
                                                />
                                            </Box>

                                            {(!(isLoading || isBankBalanceObjLoading) && (Object.keys(selectedBankObj ?? {}).length > 0)) && (
                                                <Typography
                                                    variant='body_500'
                                                    sx={{ color: palette.text.secondary }}
                                                >
                                                    Bank Sub Account Type: {`${BANK_SUB_ACCOUNT_TYPES[`${selectedBankObj?.subAccountType ?? ""}`.toUpperCase()] ?? "-"}`}
                                                </Typography>
                                            )}

                                            {(!(isLoading || isBankBalanceObjLoading) && (Object.keys(bankBalanceObj ?? {}).length > 0)) && (
                                                <Typography
                                                    variant='body_500'
                                                    sx={{ color: palette.text.secondary }}
                                                >
                                                    Available Balance: {toINR({ value: (bankBalanceObj.bankBalance ?? 0), locale, currencyCode })}
                                                </Typography>
                                            )}
                                        </Box>
                                        <Box
                                            sx={{
                                                background: palette.background.paper,
                                                padding: '25px 30px 30px',
                                                borderRadius: '20px',
                                                display: 'flex',
                                                flexDirection: 'column',
                                                gap: '35px',
                                            }}
                                            boxShadow={1}>
                                            <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                                {userLoading ? (
                                                    <CircularProgress />
                                                ) :
                                                    // (
                                                    //     <img
                                                    //         src={`https://ui-avatars.com/api/?name=${`${investorName}`}&background=${palette.primary[50]?.slice(1)}&color=${palette.primary[500]?.slice(
                                                    //             1
                                                    //         )}`}
                                                    //         style={{ borderRadius: '50%' }}
                                                    //         alt="Bank name"
                                                    //     />
                                                    // )
                                                    getAbbreviatedName(investorName ?? '')
                                                }
                                                <Box
                                                    sx={{
                                                        display: "flex",
                                                        flexDirection: "column",
                                                        rowGap: "5px",
                                                        flex: 1
                                                    }}
                                                >
                                                    {userLoading && (
                                                        <>
                                                            <Skeleton variant='text' animation="wave" />
                                                            <Skeleton variant='text' animation="wave" />
                                                        </>
                                                    )}
                                                    {!userLoading && (
                                                        <>
                                                            <Typography
                                                                variant='h2'
                                                                sx={(theme: Theme) => ({
                                                                    lineHeight: "25px",
                                                                    letterSpacing: "0.01px",
                                                                    color: theme.palette.text.primary,
                                                                    marginBottom: "5px"
                                                                })}
                                                            >
                                                                {maskInfo(investorName || '')}
                                                            </Typography>
                                                            <Box
                                                                sx={{
                                                                    display: 'flex',
                                                                    alignItems: 'center',
                                                                    columnGap: "5px"
                                                                }}
                                                            >
                                                                <Typography
                                                                    variant='body_500'
                                                                    sx={(theme: Theme) => ({
                                                                        lineHeight: "20px",
                                                                        letterSpacing: "0.02px",
                                                                        color: theme.palette.text.primary,
                                                                        whiteSpace: "nowrap"
                                                                    })}
                                                                >
                                                                    Client Code:
                                                                </Typography>
                                                                <Typography
                                                                    variant='body_500'
                                                                    sx={(theme: Theme) => ({
                                                                        display: 'flex',
                                                                        alignItems: 'center',
                                                                        lineHeight: "20px",
                                                                        letterSpacing: "0.02px",
                                                                        color: theme.palette.text.secondary,
                                                                        wordBreak: "break-word",
                                                                        maxWidth: "100%",
                                                                    })}
                                                                >
                                                                    {clientCode ?? "-"}
                                                                </Typography>
                                                            </Box>
                                                            <Box
                                                                sx={{
                                                                    display: "flex",
                                                                    alignItems: "center",
                                                                    gap: "5px",
                                                                    flexWrap: "wrap",
                                                                }}
                                                            >
                                                                {/* <Typography
                                                                variant='body_500'
                                                                sx={(theme: Theme) => ({
                                                                    lineHeight: "20px",
                                                                    letterSpacing: "0.02px",
                                                                    color: theme.palette.text.secondary,
                                                                    textTransform: "capitalize"
                                                                })}
                                                            >
                                                                {userDetails?.applicationType ?? ""}
                                                            </Typography>
                                                            <Box
                                                                sx={{
                                                                    width: "3px",
                                                                    height: "3px",
                                                                    backgroundColor: "text.secondary",
                                                                    alignSelf: "center",
                                                                    borderRadius: "50%"
                                                                }}
                                                            /> */}
                                                                <Typography
                                                                    variant='body_500'
                                                                    sx={(theme: Theme) => ({
                                                                        lineHeight: "20px",
                                                                        letterSpacing: "0.02px",
                                                                        color: theme.palette.text.secondary,
                                                                        textTransform: "capitalize"
                                                                    })}
                                                                >
                                                                    {selectedPortfolio?.label ?? ""}
                                                                </Typography>
                                                                <Box
                                                                    sx={{
                                                                        width: "3px",
                                                                        height: "3px",
                                                                        backgroundColor: "text.secondary",
                                                                        alignSelf: "center",
                                                                        borderRadius: "50%"
                                                                    }}
                                                                />
                                                                <Typography
                                                                    variant="body_500"
                                                                    sx={(theme: Theme) => ({
                                                                        lineHeight: "20px",
                                                                        letterSpacing: "0.02px",
                                                                        color: theme.palette.text.secondary
                                                                    })}
                                                                >
                                                                    {userDetails?.accountType ?? ""}
                                                                </Typography>
                                                                <Box
                                                                    sx={{
                                                                        width: "3px",
                                                                        height: "3px",
                                                                        backgroundColor: "text.secondary",
                                                                        alignSelf: "center",
                                                                        borderRadius: "50%"
                                                                    }}
                                                                />
                                                                <Typography
                                                                    variant="body_500"
                                                                    sx={(theme: Theme) => ({
                                                                        lineHeight: "20px",
                                                                        letterSpacing: "0.02px",
                                                                        color: theme.palette.text.secondary,
                                                                        textTransform: "capitalize"
                                                                    })}
                                                                >
                                                                    {userDetails?.modeOfHolding ?? ""}
                                                                </Typography>
                                                                <Box
                                                                    sx={{
                                                                        width: "3px",
                                                                        height: "3px",
                                                                        backgroundColor: "text.secondary",
                                                                        alignSelf: "center",
                                                                        borderRadius: "50%"
                                                                    }}
                                                                />
                                                                <Typography
                                                                    variant="body_500"
                                                                    sx={(theme: Theme) => ({
                                                                        lineHeight: "20px",
                                                                        letterSpacing: "0.02px",
                                                                        color: theme.palette.text.secondary
                                                                    })}
                                                                >
                                                                    {/* {
                                                                        isMinor
                                                                            ? "Minor"
                                                                            : userDetails?.status ?
                                                                                applicantStatusMasters[userDetails.status] ?
                                                                                    applicantStatusMasters[userDetails.status] : userDetails.status
                                                                                : "N/A"
                                                                    } */}
                                                                    {userDetails?.investorType ?? ""}
                                                                </Typography>
                                                                {(`${userDetails?.isFamilyHead ?? ""}`.toLowerCase() === "y") && (
                                                                    <>
                                                                        <Box
                                                                            sx={{
                                                                                width: "3px",
                                                                                height: "3px",
                                                                                backgroundColor: "text.secondary",
                                                                                alignSelf: "center",
                                                                                borderRadius: "50%"
                                                                            }}
                                                                        />
                                                                        <Typography
                                                                            variant="body_500"
                                                                            sx={(theme: Theme) => ({
                                                                                lineHeight: "20px",
                                                                                letterSpacing: "0.02px",
                                                                                color: theme.palette.text.secondary
                                                                            })}
                                                                        >
                                                                            Head Of Family
                                                                        </Typography>
                                                                    </>
                                                                )}
                                                            </Box>
                                                        </>
                                                    )}
                                                </Box>
                                            </Box>
                                            {![USER_ROLES.INVESTOR].includes(role) &&
                                                <Box width={'100%'}>
                                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px', width: '100%' }}>
                                                        <EmailIcon />
                                                        {userLoading ? (
                                                            <Skeleton variant="text" animation="wave" width={'100%'} />
                                                        ) : (
                                                            <Typography variant="body_500" fontSize={{ sm: '14px', xs: '14px', md: '16px', lg: '16px' }} color={palette.text.primary}>
                                                                {maskInfo(userDetails?.email || '')}
                                                            </Typography>
                                                        )}
                                                    </Box>
                                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px', width: '100%' }}>
                                                        <Phoneicon />
                                                        {userLoading ? (
                                                            <Skeleton variant="text" animation="wave" width={'100%'} />
                                                        ) : (
                                                            <Typography variant="body_500" fontSize={{ sm: '14px', xs: '14px', md: '16px', lg: '16px' }} color={palette.text.primary}>
                                                                {maskInfo(userDetails?.mobile || '')}
                                                            </Typography>
                                                        )}
                                                    </Box>
                                                </Box>
                                            }
                                            <Divider />
                                            <Box
                                                sx={{
                                                    display: 'flex',
                                                    flexDirection: { lg: 'column', md: 'column', sm: 'row-reverse', xs: 'row-reverse' },
                                                    gap: '10px',
                                                    justifyContent: { lg: 'center', md: 'center', sm: 'space-between', xs: 'space-between' },
                                                    alignItems: 'center',
                                                }}>
                                                {isLoading ? (
                                                    <Skeleton variant="text" animation="wave" width={100} />
                                                ) : (
                                                    <Typography variant="h1" fontSize={{ sm: '20px', xs: '20px', md: '32px', lg: '32px' }} color={palette.text.primary}>
                                                        {toINR({
                                                            value: formik.values.fund.reduce((pre: any, curr: any) => pre + (curr?.sip?.sipamount ? parseFloat(curr?.sip?.sipamount || '0') : parseFloat(curr?.lumpsum?.lumpAmount || '0')), 0),
                                                            locale,
                                                            currencyCode
                                                        }).length > 16 ? formatCurrency({
                                                            value: formik.values.fund.reduce((pre: any, curr: any) => pre + (curr?.sip?.sipamount ? parseFloat(curr?.sip?.sipamount || '0') :
                                                                parseFloat(curr?.lumpsum?.lumpAmount || '0')), 0),
                                                            locale,
                                                            currencyCode
                                                        }) :
                                                            toINR({
                                                                value: formik.values.fund.reduce((pre: any, curr: any) => pre + (curr?.sip?.sipamount ? parseFloat(curr?.sip?.sipamount || '0') : parseFloat(curr?.lumpsum?.lumpAmount || '0')), 0),
                                                                locale,
                                                                currencyCode
                                                            })}
                                                    </Typography>
                                                )}
                                                {isLoading ? (
                                                    <Skeleton variant="text" animation="wave" width={100} />
                                                ) :
                                                    <Typography variant="body_500" color={palette.text.secondary} fontSize={{ sm: '14px', xs: '14px', md: '16px', lg: '16px' }}>
                                                        Total Amount
                                                    </Typography>
                                                }
                                            </Box>
                                            <Box sx={{ display: 'flex', gap: '15px', flexDirection: 'row' }}>
                                                {![USER_ROLES.INVESTOR].includes(role) &&
                                                    <>
                                                        {(isModuleAllowed({ value: "OrderRecommend", compareArr: permissions, objKey: "permissonCode" })) && (
                                                            <CustomeButton
                                                                lookType={'outlined'}
                                                                btnText={'Recommend'}
                                                                isLoading={["recomment"].includes(apiLoading)}
                                                                disabled={
                                                                    ((formRef.current?.values?.fund ?? [])?.length || 0) === 0 ||
                                                                    isLoading ||
                                                                    isBankBalanceObjLoading ||
                                                                    ["order", "investor"].includes(apiLoading) ||
                                                                    riskPflChkLoading
                                                                }
                                                                onClick={async () => {
                                                                    setOrderType('recomment')
                                                                }}
                                                            />
                                                        )}
                                                        {(isModuleAllowed({ value: "MFOrders", compareArr: permissions, objKey: "permissonCode" })) && (
                                                            <CustomeButton lookType={'contained'} btnText={'Place Order'}
                                                                isLoading={["order"].includes(apiLoading) || riskPflChkLoading}
                                                                disabled={
                                                                    ((formRef.current?.values?.fund ?? [])?.length || 0) === 0 ||
                                                                    isLoading ||
                                                                    isBankBalanceObjLoading ||
                                                                    ["recomment", "investor"].includes(apiLoading)
                                                                }
                                                                onClick={async () => {
                                                                    setOrderType('order')
                                                                }}
                                                            />
                                                        )}
                                                    </>
                                                }
                                                {(
                                                    [USER_ROLES.INVESTOR].includes(role) &&
                                                    isModuleAllowed({ value: "MFOrders", compareArr: permissions, objKey: "permissonCode" })
                                                ) && (
                                                        <CustomeButton
                                                            lookType={'contained'}
                                                            btnText={'Add to Cart'}
                                                            isLoading={["investor"].includes(apiLoading)}
                                                            disabled={
                                                                ((formRef.current?.values?.fund ?? [])?.length || 0) === 0 ||
                                                                isLoading ||
                                                                isBankBalanceObjLoading ||
                                                                ["order", "recomment"].includes(apiLoading)
                                                            }
                                                            onClick={async () => {
                                                                setOrderType('investor')
                                                            }}
                                                        />
                                                    )}
                                            </Box>
                                        </Box>
                                    </Grid>
                                </Grid>
                            </Box>
                            {/* Document Upload Dialog Start */}
                            <TransactionsDocumentUpload
                                open={isDocumentUploadDialogVisible}
                                onClose={handleDocumentUploadDialogClose}
                            />
                            {/* Document Upload Dialog End */}

                            {/* Multiple Orders from the same scheme/folio combination Dialog start */}
                            <ConfirmRecomment
                                open={isSameSchemesDialogOpen}
                                setClose={handleSameSchemeDialogClose}
                                title="Confirm!"
                                desc="Multiple Orders with the same scheme/folio combination. Please confirm before proceeding."
                                handleConfirm={handleSameSchemeDialogConfirm}
                            />
                            {/* Multiple Orders from the same scheme/folio combination Dialog end */}
                        </>
                    )
                }}
            </Formik >

            {open &&
                isInvestMore ?
                <HoldingFundMore {...{ open, setOpen, clientCode: clientCode, holdingsData, setHoldingsData, handleProceed, setSchemeAllDetails }} /> :
                <MoreFundsModal {...{ open, setOpen, clientCode: clientCode, handleAddMoreProceed, handleAddMoreChangeRadion, radioValue, setRadioValue, setWarning, warning, setSchemeAllDetails }} />
            }
            <ConfirmRecomment
                isLoading={!!apiLoading}
                open={confirmRecomment}
                setClose={setConfirmRecomment}
                title={orderType === 'recomment' ? "Confirm Recommendation!" : orderType === 'order' ? "Confirm!" : ''}
                desc={orderType === 'recomment' ? "Are you sure you want to continue with this action ? You can see your old recommendations under recent recommendation tab." : "Are you sure you want to continue with this action ?"}
                handleConfirm={() => orderType === 'recomment' ? handleConfromRecomment() : orderType === 'order' && handleConformOrder()}
            />
            <RiskProfilePopup open={riskProfilePopup} setClose={handleRiskProfilePopup} handleConfirmOrder={handleConformOrder} isLoading={apiLoading} text={riskPopupText} apiResObj={riskProfileCheckResponse} />

            {
                cartPopup &&
                <AddtoCardPopup open={cartPopup} setClose={setCartPopup} handleSuccess={handleSuccess} />
            }
            <SuccessModal
                open={successModal}
                setClose={setSuccessModal}
                onclick={handleSuccessPopup}
                title="Success!"
                confirmBtnText={"Go to Dashboard"}
                desc={successMessage ?? ""}
            />
            <FiveSchemeErrorMessage handleCloseFiveSchemesDialog={handleCloseFiveSchemesDialog} isFiveSchemesDialogVisible={isFiveSchemesDialogVisible} />
            <ValidateDialogBox handleValidationDialogClose={handleValidationDialogClose} validationErrorsArray={validationErrorsArray} isValidationDialogVisible={isValidationDialogVisible} />

            {/* Document Upload Error Dialog Start */}
            <Dialog
                aria-labelledby="error-dialog"
                open={isDocumentUploadErrorDialogVisible}
                PaperProps={{
                    sx: {
                        maxWidth: '550px',
                        width: "100%",
                        borderRadius: "12px",
                        padding: "24px",
                        backgroundColor: palette.common.white
                    },
                }}
            >
                <DialogContent
                    sx={{
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        alignItems: "center",
                        rowGap: "12px",
                        padding: "15px",
                        overflow: "hidden"
                    }}
                >
                    <FailureIcon width="35" height="35" />
                    <Typography
                        variant="h2"
                        sx={{
                            lineHeight: "25px",
                            letterSpacing: "0.01px",
                            color: palette.text.primary
                        }}
                    >
                        Error!
                    </Typography>
                    <Typography
                        variant="subtitle_400"
                        sx={{
                            lineHeight: "22px",
                            letterSpacing: "0.02px",
                            color: palette.text.secondary,
                            textAlign: "center",
                            paddingLeft: "10px",
                            paddingRight: "10px"
                        }}
                    >
                        Please upload minimum 1 document
                    </Typography>
                </DialogContent>
                <DialogActions
                    sx={{
                        padding: "0px",
                        marginTop: "40px",
                    }}
                >
                    <Button
                        fullWidth
                        variant="contained"
                        onClick={handleDocumentUploadErrorDialogClose}
                        sx={{
                            ...typography.body_500,
                            fontWeight: 600,
                            lineHeight: "20px",
                            color: palette.common.white,
                            borderRadius: "4px",
                            padding: "13px 20px",
                            backgroundColor: palette.primary[500]
                        }}
                    >
                        Cancel
                    </Button>
                </DialogActions>
            </Dialog>
            {/* Document Upload Error Dialog End */}
        </>
    )
}

export default Transaction